import React from 'react';
import axios from "axios";

class ApiComponent extends React.Component{

    isCacheEnabled = true

    constructor(props){
        super(props);
        window.api = this;
    }

    passport(callback){
        let currentUnixTimestamp = Math.round(+new Date()/1000)
        if(localStorage.getItem('expires_in') > currentUnixTimestamp)
        {
            callback({
                status: 'exist',
                access_token: localStorage.getItem('access_token')
            })
        } else {
            axios.post(process.env.REACT_APP_BACKEND_BASE_URL + "oauth/token", {
                    grant_type: process.env.REACT_APP_BACKEND_GRANT_TYPE,
                    client_id: process.env.REACT_APP_BACKEND_CLIENT_ID,
                    client_secret: process.env.REACT_APP_BACKEND_CLIENT_SECRET,
                    username: process.env.REACT_APP_BACKEND_USERNAME,
                    password: process.env.REACT_APP_BACKEND_PASSWORD
                }
            ).then(res => {
                let unix = Math.round(+new Date()/1000) + res.data.expires_in
                localStorage.setItem('expires_in', unix)
                localStorage.setItem('access_token', res.data.access_token)
                callback({
                    status: 'new',
                    access_token: res.data.access_token
                })
            }).catch(ex => {
                console.log(ex.message)
            })
        }
    }

    useCache(key, callback) {
        if(this.isCacheEnabled)
        {
            try {
                const name = "cache-" + key;
                const json = localStorage.getItem(name);
                const data = JSON.parse(json);
                callback(data.data);
            } catch (error) {
                callback(false);
            }
        } else {
            callback(false);
        }
    }

    useRawCache(key, callback) {
        if(this.isCacheEnabled)
        {
            try {
                const name = "cache-" + key;
                const json = localStorage.getItem(name);
                const data = JSON.parse(json);
                callback(data);
            } catch (error) {
                callback(false);
            }
        }
    }

    saveCache(key, value) {
        if(this.isCacheEnabled)
        {
            const name = "cache-" + key;
            const currentTime = new Date().getTime();
            const payload = {
                time: currentTime,
                data: value
            }
            const json = JSON.stringify(payload);

            this.useRawCache(key, res => {
                if(res) {
                    try
                    {
                        // ตรงนี้ยังไม่ชัวร์
                        if( (res.time + (1800 * 1000)) < currentTime )
                        {
                            localStorage.setItem(name, json);
                        }
                    } catch (e) {
                        localStorage.setItem(name, json);
                    }
                } else {
                    localStorage.setItem(name, json);
                }
            });
        }
    }

    disableCache()
    {
        this.isCacheEnabled = false;
    }

    enableCache()
    {
        this.isCacheEnabled = true;
    }

    getStorage(path){
        if(path)
        {
            return process.env.REACT_APP_BACKEND_BASE_URL + "storage/" + path.replaceAll('\\', '/')
        } else {
            return false
        }
    }

    render(){
        return (
            <div />
        )
    }
}

export default ApiComponent;